import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;
const RELEASE = import.meta.env.VITE_SENTRY_RELEASE;

export const initSentry = () => {
  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not found. Error tracking will be disabled.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: RELEASE,
    enabled: ENVIRONMENT === 'production' || import.meta.env.VITE_ENABLE_SENTRY === 'true',

    // Browser timing: page loads, navigations, API calls and long render tasks.
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    // The API's CORS list does not allow sentry-trace/baggage headers, so do not send them.
    tracePropagationTargets: [],

    // Ignore some common errors that aren't actionable
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage',
    ],
  });
};

/**
 * Set user context on Sentry
 */
export const setSentryUser = (userId: string, email?: string) => {
  Sentry.setUser({ id: userId, email });
};

/**
 * Capture an exception with optional context
 */
export const captureException = (error: Error, context?: Record<string, unknown>) => {
  Sentry.captureException(error, { extra: context });
};

/**
 * Add a breadcrumb for debugging context
 */
export const addBreadcrumb = (message: string, data?: Record<string, unknown>) => {
  Sentry.addBreadcrumb({
    message,
    data,
    level: 'info',
  });
};
